import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Header from '@components/Header'
import Footer from '@components/Footer'
import Breadcrumbs from '@components/Breadcrumbs'
import '@styles/global.scss'

class Layout extends Component {
  constructor () {
    super()
    this.state = { pageDidLoad: false, scrolled: false }
  }
  handleScroll = () => {
    let scrollHeight = window.scrollY
    if (scrollHeight > 100) {
      this.setState({ scrolled: true })
    } else {
      this.setState({ scrolled: false })
    }
  }
  componentDidMount () {
    this.setState({ pageDidLoad: typeof window !== 'undefined' && window })
    if (window) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }
  render () {
    const { children, data, location } = this.props
    const footer = R.propOr(null, 'contentfulHeaderFooterComponent', data)
    const breadcrumbsIgnore = R.pathOr(null, ['contentfulSiteConfiguration', 'breadcrumbsIgnore'], data)
    const menu = R.propOr([], 'menu', footer)
    const siteSearchIndex = R.propOr(null, 'siteSearchIndex', data)
    return (
      this.state.pageDidLoad && (
        <Fragment>
          <Header links={menu} siteSearchData={siteSearchIndex} location={location} />
          <div className='page'>
            <Breadcrumbs location={location} ignoreList={breadcrumbsIgnore} />
            {children()}
          </div>
          <div className='stickTab'>
            <a className={`${this.state.scrolled ? 'scroll' : ''}`} href='/request-a-quote'>
              Request a Quote
            </a>
          </div>
          <Footer data={footer} />
        </Fragment>
      )
    )
  }
}

Layout.propTypes = {
  children: PropTypes.func
}

export const query = graphql`
  query headerQuery {
    contentfulHeaderFooterComponent {
      menu {
        ... on ContentfulNavigationNodeComponent {
          title
          externalLink
          link {
            slug
          }
          subMenu {
            title
            link {
              slug
            }
            externalLink
          }
          showContent
          content {
            content
          }
          linkBox {
            title
            link {
              slug
              ... on ContentfulPage {
                template {
                  __typename
                  ... on ContentfulProductTemplate {
                    title
                    shortName
                    category
                  }
                }
              }
            }
            image {
              resize {
                src
              }
            }
            description {
              description
            }
          }
          brochure {
            ... on ContentfulBrochuresComponent {
              title
              description
              category
              coverImage {
                resize(width: 300) {
                  src
                }
              }
              brochure {
                file {
                  url
                }
              }
              linkUrl
            }
          }
        }
      }
      legalText
      legalMenu {
        ... on ContentfulNavigationNodeComponent {
          title
          link {
            slug
          }
        }
      }
      smallNavigationTitle
      smallNavigationMenu {
        ... on ContentfulNavigationNodeComponent {
          title
          externalLink
          link {
            slug
          }
        }
      }
      largeNavigationTitle
      largeNavigationMenu {
        ... on ContentfulNavigationNodeComponent {
          title
          externalLink
          link {
            slug
          }
          externalLink
        }
      }
      twitter
      linkedin
      instagram
      facebook
      youtube
      mailingListTitle
      mailingListThankYouMessage
    }
    contentfulSiteConfiguration(title: { eq: "Primary" }) {
      breadcrumbsIgnore
      cookieMessage {
        childMarkdownRemark {
          html
        }
      }
    }
    siteSearchIndex {
      index
    }
  }
`

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js